import React from 'react'
import { AddQuestionModalProvider } from './context/AddQuestionModalProvider'
import { AddQuestionModalMain } from './components/AddQuestionModalMain'

type AddQuestionModalProps = {
  requirementId: number
  open: boolean
  onClose: () => void
}

export const AddQuestionModal = ({
  requirementId,
  open,
  onClose,
}: AddQuestionModalProps) => (
  <AddQuestionModalProvider
    requirementId={requirementId}
    open={open}
    onClose={onClose}
  >
    <AddQuestionModalMain />
  </AddQuestionModalProvider>
)
